import React from 'react';
import ReactDOMServer from 'react-dom/server';

import { IndustryIcon } from 'app/components/DetailsPages/shared/CommonGround/Icons';

import { IDrawer } from '../../../PublicationContent';
import './styled';
import {
  DataTypeIndustryIconContainer,
  DataTypeIndustryPillText,
  DataTypeIndustryPillWrapper,
} from './styled';

export const dataTypeIndustryContentModifier = (
  node: HTMLDivElement,
  setDrawer: React.Dispatch<React.SetStateAction<IDrawer>>
) => {
  node.querySelectorAll('[data-type="industries"], [data-type="industry"]').forEach((industry) => {
    const slug = industry.getAttribute('data-slug');
    const name = industry.textContent;
    const template = document.createElement('div');
    template.innerHTML = ReactDOMServer.renderToString(<DataTypeIndustryPill name={name || ''} />);

    template.firstChild.addEventListener('click', () => {
      setDrawer({ show: true, slug, type: 'industries' });
    });

    industry.replaceWith(template.firstChild);
  });
};

interface DataTypeIndustryPillProps {
  name: string;
}

export const DataTypeIndustryPill = ({ name }: DataTypeIndustryPillProps) => {
  return (
    <DataTypeIndustryPillWrapper>
      <DataTypeIndustryIconContainer>
        <IndustryIcon width={16} height={16} fill={'var(--color-data-industry-foreground)'} />
      </DataTypeIndustryIconContainer>
      <DataTypeIndustryPillText>{name}</DataTypeIndustryPillText>
    </DataTypeIndustryPillWrapper>
  );
};
